"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _serializeError = function serializeError(error) {
  var recurse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var name = error.name,
    message = error.message,
    _error$stack = error.stack,
    stack = _error$stack === void 0 ? '' : _error$stack,
    cause = error.cause;
  var truncatedStack = stack.slice(0, 400);
  var causeError = recurse && cause ? _serializeError(cause) : undefined;
  return {
    name: name,
    message: message,
    stack: "".concat(truncatedStack, "..."),
    cause: causeError
  };
};
var ConfigurationError = /*#__PURE__*/function (_Error) {
  function ConfigurationError(message) {
    var _this;
    (0, _classCallCheck2["default"])(this, ConfigurationError);
    _this = _callSuper(this, ConfigurationError, [message]);
    _this.name = "ConfigurationError";
    return _this;
  }
  (0, _inherits2["default"])(ConfigurationError, _Error);
  return (0, _createClass2["default"])(ConfigurationError);
}(/*#__PURE__*/(0, _wrapNativeSuper2["default"])(Error));
exports = module.exports = {
  serializeError: _serializeError,
  ConfigurationError: ConfigurationError
};